import React from "react";
import GitHubIcon from '@material-ui/icons/GitHub';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';

import './footer.css'

const Footer = () => {
    return (
        <footer className="footerMain">
            <div className="container">
                <div className="row">
                    <div className="footer-col">
                        <h4>company</h4>
                        <ul>
                            <li><a href="https://github.com/SanjaySantokee">about us</a></li>
                            <li><a href="https://github.com/SanjaySantokee">Meetings</a></li>
                            <li><a href="https://github.com/SanjaySantokee">Calling</a></li>
                            <li><a href="https://github.com/SanjaySantokee">Messaging</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>get help</h4>
                        <ul>
                            <li><a href="https://github.com/SanjaySantokee">FAQ</a></li>
                            <li><a href="https://github.com/SanjaySantokee">Contact Support</a></li>
                            <li><a href="https://github.com/SanjaySantokee">Contact Sales</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>Legal</h4>
                        <ul>
                            <li><a href="https://github.com/SanjaySantokee">Terms & Conditions</a></li>
                            <li><a href="https://github.com/SanjaySantokee">Privacy Statement</a></li>
                            <li><a href="https://github.com/SanjaySantokee">Cookies</a></li>
                            <li><a href="https://github.com/SanjaySantokee">Trademarks</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>follow us</h4>
                        <div className="social-links">
                            <a target="_blank" rel="noopener noreferrer" href="https://github.com/SanjaySantokee"><GitHubIcon/></a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/sanjaysantokee/"><LinkedInIcon/></a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/sanjaysantokee/"><FacebookIcon/></a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/sanjay.santokee/"><InstagramIcon/></a>
                        </div>
                    </div>
                    <h5>Copyright &copy; 2021 All Rights Reserved by SUMMIT</h5>
                </div>
            </div>
        </footer>
    );
}

export default Footer;